import { whitelistSpecialNeeds } from "./whitelistSpecialNeeds";

export const getPassengerCounts = (passengerList) => {
  const initialCounts = {
    countAdultsCheckedIn: 0,
    countInfantsCheckedIn: 0,
    countAdultsBoarded: 0,
    countInfantsBoarded: 0,
    countCheckedIn: 0,
    countNotCheckedIn: 0,
    countInfantNotCheckedIn: 0,
    countInfants: 0,
    countSpecialNeeds: 0,
    countConnectedFlights: 0,
  };

  return passengerList.reduce((acc, passenger) => {
    const { checkedIn, boarded, isInfant, services, connectingFlight } =
      passenger;

      if (checkedIn) {
        acc.countCheckedIn++;
      isInfant ? acc.countInfantsCheckedIn++ : acc.countAdultsCheckedIn++;
      } else {
        isInfant ? acc.countInfantNotCheckedIn++ : acc.countNotCheckedIn++;
      }

      if (boarded) {
        isInfant ? acc.countInfantsBoarded++ : acc.countAdultsBoarded++;
      }

      if (isInfant) acc.countInfants++;

    if (whitelistSpecialNeeds({ services })) acc.countSpecialNeeds++;
      if (connectingFlight) acc.countConnectedFlights++;

      return acc;
  }, initialCounts);
};
